import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { MetaService } from 'src/app/services/meta.service';

import * as moment from 'moment';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {

  public serviceAgents = [];

  constructor(private usersService: UserService, private metaService: MetaService, private snackBar: MatSnackBar, private router: Router) { }

  ngOnInit() {
    this.metaService.getMetaData().subscribe(result => {
      if (result.success) {
        this.serviceAgents = result.data.serviceAgents;
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    })
  }

  onAddUser(form: NgForm) {
    form.value.dateOfBirth = moment(form.value.dateOfBirth).format('DD-MM-YYYY');
    form.value.building = form.value.building || '-';

    const data = new FormData();
    data.append('users', JSON.stringify([form.value]));

    this.usersService.addUserAdAdmin(data).subscribe(result => {
      if (result.success) {
        this.router.navigate(['/admin/users']);
        this.snackBar.open('User successfully added', 'Dismiss', {
          duration: 3000
        });
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    })
  }
}
